// css =>
import "../../BaseStructure.css";
import Styled from "./project-picture-box.module.css";

const ProjectPictureBox = (props) => {
    return (
        <div
            className={`col-4 ${ Styled.ProjectPictureBox } `}>
            <img src={ props.projectPicture } alt="Project" loading="lazy" />
        </div>
    );
}

export default ProjectPictureBox;
